export default "__VITE_ASSET__djoSRHcP__"